import React from 'react';

const Notification = ({ type, message, onClose }) => {
  const styles = {
    success: {
      container: 'bg-green-100 border-green-400 text-green-700 dark:bg-green-900 dark:border-green-700 dark:text-green-100',
      icon: 'text-green-500 dark:text-green-400',
      iconBg: 'bg-green-200 dark:bg-green-800'
    },
    error: {
      container: 'bg-red-100 border-red-400 text-red-700 dark:bg-red-900 dark:border-red-700 dark:text-red-100',
      icon: 'text-red-500 dark:text-red-400',
      iconBg: 'bg-red-200 dark:bg-red-800'
    }
  };

  const selectedStyle = styles[type];

  return (
    <div className="fixed top-4 right-4 z-50 animate-fade-in">
      <div className={`${selectedStyle.container} border px-4 py-3 rounded relative shadow-lg max-w-md w-[calc(100vw-2rem)] sm:w-auto`} role="alert">
        <div className="flex items-start gap-3 pr-8">
          <div className={`${selectedStyle.iconBg} p-2 rounded-full shrink-0`}>
            {type === 'success' ? (
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
              </svg>
            ) : (
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            )}
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm sm:text-base break-words">{message}</p>
          </div>
          <button
            className="absolute top-2 right-2 p-1 hover:bg-opacity-10 hover:bg-black dark:hover:bg-white rounded-full transition-colors duration-200"
            onClick={onClose}
            aria-label="Close notification"
          >
            <svg 
              className={`w-5 h-5 ${selectedStyle.icon}`} 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth="2" 
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Notification; 